/** What the page can use to copy: the async clipboard (missing on plain http) and a select-and-copy fallback. */
export interface ApiTokenCopyEnvironment {
    clipboard: { writeText(text: string): Promise<void> } | undefined;
    /** Selects the shown token and runs the legacy copy command; true when the browser reports success. */
    selectAndCopy(): boolean;
}

/**
 * Copies a newly created token: the async clipboard when it is there and allowed, else select and
 * `execCommand('copy')`, else the page asks to copy by hand. `navigator.clipboard` is missing on a
 * plain-http host (measured on the local stack), so the fallback is not theoretical.
 */
export async function copyApiToken(token: string, environment: ApiTokenCopyEnvironment): Promise<'clipboard' | 'selected' | 'manual'> {
    if (environment.clipboard) {
        try {
            await environment.clipboard.writeText(token);

            return 'clipboard';
        } catch {
            // Refused (no permission, no focus): try the fallback below.
        }
    }

    return environment.selectAndCopy() ? 'selected' : 'manual';
}
